import React, { useState } from "react";
import { Modal } from "@/components/Layout";
import { MONTHS } from "./TimeentriesFilters";

/** Confirmare pentru validarea / deblocarea lunii unui raport de muncă. */
export default function TimeentriesValidationModal({ target, month, onClose, onConfirm }) {
  const [busy, setBusy] = useState(false);
  const unlock = target.validated;
  const go = async () => { setBusy(true); try { await onConfirm(); } finally { setBusy(false); } };
  return (
    <Modal title={unlock ? "Deblocare pontaj" : "Validare pontaj"} onClose={onClose} width={480}>
      <p style={{ fontSize: 14, color: "#334155", marginTop: 0 }} data-testid="te-validation-text">
        {unlock
          ? "Deblocați pontajul? Veți putea modifica din nou."
          : `Confirmați validarea pontajului pentru ${target.name} luna ${MONTHS[month - 1]}? Nu veți putea modifica până nu deblocați.`}
      </p>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 18 }}>
        <button className="btn btn-secondary" onClick={onClose}>Anulează</button>
        <button className="btn btn-primary" disabled={busy} onClick={go} data-testid="te-validation-confirm">
          {unlock ? "Deblochează" : "Validează"}
        </button>
      </div>
    </Modal>
  );
}
